@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.dropdownBody {
  width: 208px;
}

.item {
  color: var(--neutral-90);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 8px;
  border-radius: 4px;
  cursor: pointer;

  svg {
    color: var(--dark-100);
  }

  &:hover {
    @include blur;
  }

  &.selected {
    background: var(--selected-fill);
    color: var(--light-100);
    svg {
      color: var(--light-100);
    }

    &:hover {
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.05) 100%), var(--selected-fill);
    }
  }
}

.title {
  @include md-medium;
  padding-left: 8px;
  display: flex;
  align-items: flex-start;
  align-self: stretch;
}

.check {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.lineDivider {
  height: 1px;
  background: var(--neutral-10);
  margin: 4px 0 4px 8px;
  padding: 0 8px;
  width: calc(100% - 16px);
}

.rightContent {
  margin-left: auto;
}

.comingSoon {
  @include sm-regular;
  display: flex;
  padding: 2px 8px;
  height: 20px;
  align-items: center;
  align-self: stretch;
  border-radius: 16px;
  background-color: var(--neutral-5);
  color: var(--neutral-30);
}

button.dropdownButton.textStylesButton:not(.useIcon) {
  width: auto;
}

.label {
  padding: 0 3px;
}

.button {
  padding: 6px !important;
  min-width: 36px !important;
  height: 36px !important;

  svg {
    width: 24px;
    height: 24px;
  }
}

@media (min-width: $phoneMaxWidth) {
  .button {
    min-width: 40px !important;
    height: 40px !important;
    padding: 10px !important;

    [data-autopilot-system-redesign='on'] & {
      min-width: 32px !important;
      height: 32px !important;
      padding: 8px !important;
    }

    svg {
      width: 20px;
      height: 20px;

      [data-autopilot-system-redesign='on'] & {
        width: 18px !important;
        height: 18px !important;
      }
    }
  }
}
